import {useParams} from '@aboutyou/router';

export const useGetActiveSectionId = () => {
  // in case the sections name has a '-' eg /h/secondhand-service-4401167846556
  // the params are incorrectly captured as {sectionName: 'secondhand', sectionid: 'service-4401167846556'}
  //
  // this could lead to a unknown sectionId and return 404
  const params = useParams<{sectionId?: `${string}${number}`}>();

  return parseFloat((params?.sectionId || '').replace(/\D*/, ''));
};
